import each from 'lodash/each';
/**
 * Multiple custom event subscriber
 * Emits an Obnservable to an event stream and passing it further as custom event message
 * @param eventList `CustomEventStream[]` list of events to substribe to
 * @returns void
 */
export function customEventsSubscriber(eventList) {
    each(eventList, customEvent => {
        window.addEventListener(customEvent.event, (event) => {
            customEvent.stream.next(event.detail);
        });
    });
}
